import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, EntitiesService, GenesisUnitOfWork, ReportService, SessionInformationService } from 'app/core/core.module';
import { AssemblySchedule, Confirmation, OrderLineDetail } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent, DxMapComponent } from 'devextreme-angular';
// import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import moment from 'moment';

@Component({
    selector: 'app-order-map',
    templateUrl: './order-map.component.html',
    styleUrls: ['./order-map.component.scss'],
    standalone: false
})
export class OrderMapComponent implements OnInit {
    filter: any;
    statuses: any[];
    selectedStatuses = [];
    keys = {
        azure: 'CQKaJUZCB0DtcAJSctShFlZLAb8MyWQwXDRGm95e4vDDNG3CyaBiJQQJ99BGACYeBjFY54PIAAAgAZMP3hW4',
    };
    markerUrl = 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png';
    markers: any;
    processing = true;
    selectedBuildParts = [];
    selectedShipParts = [];
    showSideBar = false;
    showVendorPickups: boolean;
    orderLineDetails: OrderLineDetail[] = [];

    router = inject(Router);
    @ViewChild('map') map: DxMapComponent;
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    async onExporting(e) {
        SharedModule.onExportingGrid(e.component, this.entitiesService.optionsAndNotesCustomizeCellOverride);
    }

    constructor(
        private uow: GenesisUnitOfWork,
        public auth: AuthService,
        private appInfo: AppInformationService,
        private reportService: ReportService,
        private entitiesService: EntitiesService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        const showVendorPickups = this.sessionInfo.getItem('show-vendor-pickups', true);
        this.showVendorPickups = showVendorPickups == null ? false : showVendorPickups;
        this.statuses = this.uow.lookups.orderLineStatuses.filter((x) => {
            if (x.id !== OrderLineDetail.Statuses.DeliveredPickedUp && x.id !== OrderLineDetail.Statuses.Complete) return x;
        });
        this.filter = {};
        this.markers = [];
        window['toolTipClicked'] = (id) => {
            console.log('tooltip clicked');
        };
        window['component'] = this;
    }

    //https://supportcenter.devexpress.com/ticket/details/t537072/dxmap-custom-tooltip-html-for-markers-with-angular-directives
    async getData() {
        this.appInfo.pleaseWaitShow();
        this.map.markers = [];
        let markers = [];
        if (this.selectedStatuses?.length !== 0) {
            markers = (await this.uow.getMapData(this.selectedStatuses)) as any[];
            this.map.instance.beginUpdate();
            for (let index = 0; index < markers.length; index++) {
                const marker = markers[index];
                let statusString = [];
                marker.data.forEach((status) => {
                    statusString.push(`${status.statusName} - ${status.statusCount}`);
                });
                if (marker.city !== null && marker.state !== null) {
                    let markerIcon = `./assets/images/${marker.mapIcon ?? 'map-marker-red'}.png`;
                    await this.map.instance.addMarker({
                        location: marker.location,
                        iconSrc: markerIcon,
                        tooltip: {
                            text: `${marker.dealer}</br><span class="tool-tip-class" >${statusString.join(
                                '<br>'
                            )} <button class="ms-2 btn btn-sm btn-success" onclick="component.viewOrder(${marker.dealerId})">View Order</button><span>`,
                            isShown: false,
                        },
                        onClick: this.toolTipClicked,
                    });
                }
            }
        }
        if (this.showVendorPickups) {
            const pickUpMarkers = (await this.uow.getVendorPickupMapData()) as any[];
            for(let marker of pickUpMarkers) {
                if (marker.city !== null && marker.state !== null) {
                    await this.map.instance.addMarker({
                        location: marker.location,
                        iconSrc: './assets/images/map-marker-blue.png',
                        tooltip: {
                            text: `${marker.vendor}</br><span class="tool-tip-class"><span>`,
                            isShown: false,
                        },
                    });
                }
                markers.push(marker);
            }
        }
        this.markers = markers;
        let i = 1;
        this.markers.forEach((marker) => {
            marker.id = i;
            i++;
        });
        this.map.instance.endUpdate();
        this.appInfo.pleaseWaitHide();
    }
    toolTipClicked() {
        console.log('tooltip clicked');
    }
    toggleParts() {
        this.showSideBar = !this.showSideBar;
    }
    async viewOrder(dealerId) {
        this.appInfo.pleaseWaitShow();
        const orderLineDetails = (await this.uow.getMapDataByDealer(dealerId, this.selectedStatuses)) as OrderLineDetail[];
        // for now just clear the list everytime the add to it
        // orderLineDetails.forEach(detail => {
        //     this.orderLineDetails.push(detail);
        // });
        this.orderLineDetails = orderLineDetails;

        this.entitiesService.setNoteHtml(this.orderLineDetails);

        this.entitiesService.setOptionHtml(this.orderLineDetails);

        // confirmation
        this.orderLineDetails.forEach((detail: any) => {
            if (!detail.orderLine.order.confirmations) return;

            const confirmations = detail.orderLine.order.confirmations.filter(
                (confirmation: Confirmation) => !confirmation.salesRepConfirmation && !confirmation.deleted && confirmation.approved
            );
            if (confirmations && confirmations.length > 0) {
                const approvedDate = _(confirmations).orderBy('created', 'desc').valueOf()[0].approved;
                detail.confirmationApproved = approvedDate;
                // detail.dueDate = moment(approvedDate).add(14, 'days').toDate();
            }
        });
        this.appInfo.pleaseWaitHide();
    }

    removeFromOrder() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData() as OrderLineDetail[];
        if (!selectedRows) return;

        const ids = selectedRows.map((detail) => detail.id);
        this.orderLineDetails = this.orderLineDetails.filter((detail) => !ids.includes(detail.id));
    }

    addToList(mode: string) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        this.showSideBar = true;
        selectedRows.forEach((row) => {
            if (mode === 'build') this.selectedBuildParts.push(row);
            else this.selectedShipParts.push(row);
        });
    }

    removeFromSelected(info: any, mode: string) {
        const list = mode === 'build' ? this.selectedBuildParts : this.selectedShipParts;
        const index = list.indexOf(info);
        if (index >= 0) list.splice(index, 1);
    }

    async printBuildList(mode: string) {
        // const rows = this.dataGrid.instance.getSelectedRowsData();
        const rows = mode === 'build' ? this.selectedBuildParts : this.selectedShipParts;
        if (!rows || rows.length === 0) return;

        const ids = rows.map((x) => {
            return x.id;
        });
        ids.forEach((id) => {
            const schedule = this.uow.assemblySchedules.createEntity() as AssemblySchedule;
            schedule.buildDate = new Date();
            schedule.created = new Date();
            schedule.createdBy = this.auth.currentUser.userName;
            schedule.jigId = 1;
            schedule.orderLineDetailId = id;
        });
        await this.uow.commit();
        await this.reportService.printAssemblySchedule({ ids: ids, mode: mode.toUpperCase() });
    }

    async searchByStatus() {
        this.sessionInfo.setItem('show-vendor-pickups', this.showVendorPickups, true);
        await this.getData();
    }

    async refresh() {
        await this.getData();
    }

    clear() {
        this.map.markers = [];
        this.markers = [];
        this.selectedStatuses = [];
    }

    onRowPrepared(e) {
        if (e.rowType === 'data' && !!e.data.vendor) {
            e.rowElement.className = e.rowElement.className + ' light-blue-line';
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async openPO(marker) {
        this.router.navigate([`/purchase-orders/${marker.pOId}`]);
    }
}
class Tooltip {
    isShown: boolean;
    text: string;
}

class Marker {
    location: any;
    tooltip: Tooltip;
}
